import { createContext, useContext, ReactNode } from "react";
import { trpc } from "@/lib/trpc";
import { APP_TITLE, APP_LOGO } from "@/const";

interface BrandingContextValue {
  appTitle: string;
  appLogo: string;
  isLoading: boolean;
}

const BrandingContext = createContext<BrandingContextValue>({
  appTitle: APP_TITLE,
  appLogo: APP_LOGO,
  isLoading: false,
});

export function BrandingProvider({ children }: { children: ReactNode }) {
  const { data: settings, isLoading } = trpc.settings.getSystemSettings.useQuery(undefined, {
    staleTime: 5 * 60 * 1000, // cache 5 minutes
    retry: false,
  });

  const appTitle =
    (settings?.organizationName && settings.organizationName.trim())
      ? settings.organizationName
      : APP_TITLE;

  const appLogo =
    (settings?.organizationLogo && settings.organizationLogo.trim())
      ? settings.organizationLogo
      : APP_LOGO;

  return (
    <BrandingContext.Provider value={{ appTitle, appLogo, isLoading }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
